class Metrics {

  constructor(basePath, baseUserPath, apiClient) {

    this.basePath = `${basePath}/metrics`;
    this.baseUserPath = `${baseUserPath}/metrics`;
    this.apiClient = apiClient;

  }

  async getAllSystemMetrics() {

    return this.apiClient.get(this.basePath, {}, {});

  }

  async createSystemMetric(metric) {

    return this.apiClient.post(this.baseUserPath, {}, {}, metric);

  }

}

export default Metrics;